<template>
<section class="content" style="min-height: 873px;">

    <div class="navbar bg-blue">

        <center>
            <h3>{{title | translate }}</h3>
            <h5>{{ $t('REFRESHING_IN')}} {{hora}}</h5>
        </center>
    </div>
    <hr>
    <a ref="nofollow" :href="thisLink"></a>
    <div class="row">
        <div class="col col-md-2">
            <div class="box box-success direct-chat direct-chat-success">
                <div class="box-header with-border">
                    <h3 class="box-title"> {{ UP_MONIT | translate}}</h3>

                    <div class="box-tools pull-right">
                        <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i>
                </button>

                        <button type="button" class="btn btn-box-tool" data-widget="remove"><i class="fa fa-times"></i></button>
                    </div>
                </div>
                <!-- /.box-header -->
                <div class="box-body ">
                    <!-- Conversations are loaded here -->
                    <vue-good-table :columns="columns" :rows="Monitorslist.up" :searchOptions="{
                                    enabled: true,
                                    trigger: 'enter',
                                    placeholder: this.$t('SEARCH'),
                                  }" :pagination-options="{
                                      enabled: true,
                                      dropdownAllowAll: false,
                                      nextLabel: $t('TRANSACTION_TABLE.NEXT') ,
                                      prevLabel:$t('TRANSACTION_TABLE.BACK') ,
                                      ofLabel: $t('TRANSACTION_TABLE.OF') ,
                                      perPage: 5,
                                      perPageDropdown: [10,5],
                                      rowsPerPageLabel:$t('TRANSACTION_TABLE.ROWS_PER_PAGES'),
                                        
                                       }" styleClass="vgt-table condensed"></vue-good-table>
                    <!-- /.direct-chat-pane -->
                </div>
            </div>

        </div>
        <section class="col col-md-8">
            <!-- DIRECT CHAT PRIMARY -->
            <div class="box box-primary direct-chat direct-chat-primary">

                <div class="box-header with-border bg-blue">

                    <h3 style="color:white;"><i class="ion ion-pie-graph"></i> {{ QUICK_STATS | translate }}</h3>

                    <div class="box-tools pull-right">

                        <button type="button" class="btn btn-box-tool" data-widget="collapse">
                                    <i class="fa fa-minus"></i>
                                </button>

                        <button type="button" class="btn btn-box-tool" data-widget="remove">
                                    <i class="fa fa-times"></i>
                                </button>
                    </div>
                </div>
                <!-- /.box-header -->
                <div class="box-body">
                    <div class="jumbotron bg-white">
                        <div class="row">

                            <div class="col-lg-4 col-sm-4 col-xs-4">

                                <div class="small-box bg-white">

                                    <div class="inner">
                                        <center>
                                            <h4><i class="fa fa-circle text-green"></i>{{ UP_MONIT | translate}}</h4>
                                            <hr>

                                            <knob-control v-model="up" :diameter="size" :animateSpeed="speed" :startColor="'#2aa33e'" :strokeWidth="grosor" :completed-steps="up" :total-steps="maxZise">
                                                <div class="font-weight-bold text-success" style="font-size: 25px;" >{{up}}</div>
                                            </knob-control>

                                        </center>
                                    </div>

                                </div>
                            </div>
                            <!-- ./col -->
                            <div class="col-lg-4 col-sm-4 col-xs-4">
                                <!-- small box -->
                                <div class="small-box bg-white">
                                    <div class="inner">

                                        <center>
                                            <h4><i class="fa fa-circle text-red"></i>{{ DOWN_MONIT | translate}}</h4>
                                            <hr>
                                            <knob-control v-model="downs" :diameter="size" :animateSpeed="speed" :startColor="'#d50000'" :strokeWidth="grosor" :stopColor="'#d50000'" :completed-steps="downs" :total-steps="maxZise" text-color="#d50000">
                                                <div class="font-weight-bold text-danger" style="font-size: 25px;" >{{downs}}</div>
                                            </knob-control>

                                        </center>
                                    </div>

                                </div>
                            </div>
                            <!-- ./col -->
                            <div class="col-lg-4 col-sm-4 col-xs-4">
                                <!-- small box -->
                                <div class="small-box bg-white">
                                    <div class="inner">

                                        <center>
                                            <h4><i class="fa fa-circle text-black"></i>{{ PAUSED_MONIT | translate}}</h4>
                                            <hr>
                                             <knob-control v-model="downs" :diameter="size" :animateSpeed="speed" :startColor="'#263238'" :strokeWidth="grosor" :stopColor="'#263238'" :completed-steps="pauses" :total-steps="maxZise" >
                                                 <div class="font-weight-bold " style="font-size: 25px;">{{pauses}}</div>
                                             </knob-control>
                                           
                                        </center>
                                    </div>

                                </div>
                            </div>
                            <!-- ./col -->

                        </div>
                    </div>
                </div>

            </div>
            <!--/.direct-chat -->
        </section>
        <!-- /.col -->
        <section class="col col-md-2">
            <div class="box box-danger direct-chat direct-chat-primary">
                <div class="box-header with-border">
                    <h3 class="box-title">{{ DOWN_MONIT | translate}}</h3>

                    <div class="box-tools pull-right">
                        <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i>
                </button>

                        <button type="button" class="btn btn-box-tool" data-widget="remove"><i class="fa fa-times"></i></button>
                    </div>
                </div>
                <!-- /.box-header -->
                <div class="box-body">
                    <!-- Conversations are loaded here -->
                    <vue-good-table :columns="columns" :rows="Monitorslist.down" :searchOptions="{
                                    enabled: true,
                                    trigger: 'enter',
                                    placeholder: this.$t('SEARCH'),
                                  }" :pagination-options="{
                                      enabled: true,
                                      dropdownAllowAll: false,
                                      nextLabel: $t('TRANSACTION_TABLE.NEXT') ,
                                      prevLabel:$t('TRANSACTION_TABLE.BACK') ,
                                      ofLabel: $t('TRANSACTION_TABLE.OF') ,
                                       perPage: 5,
                                        perPageDropdown: [10,5],
                                      rowsPerPageLabel:$t('TRANSACTION_TABLE.ROWS_PER_PAGES'),
                                        
                                       }" styleClass="vgt-table condensed"></vue-good-table>
                    <!-- /.direct-chat-pane -->
                </div>
            </div>

        </section>
    </div>
    <div class="row">
        <div class="col col-sm-12">

            <div class="col col-sm-6">
                <div class="box box-primary direct-chat direct-chat-primary">
                    <div class="box-header with-border">
                        <h3 class="box-title"> {{ $t('UPTIMEROBOT.LASTEST_EVENT_FOR_ALL_MONITORS') }}</h3>

                        <div class="box-tools pull-right">
                            <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i>
                </button>

                            <button type="button" class="btn btn-box-tool" data-widget="remove"><i class="fa fa-times"></i></button>
                        </div>
                    </div>
                    <div class="box-body">
                        <vue-good-table :columns="enventsColums" :rows="eventsRows" styleClass="vgt-table condensed" :searchOptions="{
                                    enabled: true,
                                    trigger: 'enter',
                                    placeholder: this.$t('SEARCH'),
                                  }" :pagination-options="{
                                      enabled: true,
                                      dropdownAllowAll: false,
                                      nextLabel: $t('TRANSACTION_TABLE.NEXT') ,
                                      prevLabel:$t('TRANSACTION_TABLE.BACK') ,
                                      ofLabel: $t('TRANSACTION_TABLE.OF') ,
                                      rowsPerPageLabel:$t('TRANSACTION_TABLE.ROWS_PER_PAGES'),
                                      perPage: 5,
                                    perPageDropdown: [10,5],
                                        
                                       }">
                            <template slot="table-column" slot-scope="props">
                                <th v-if="props.column.field == 'type'"> {{ props.column.label | translate }}</th>
                                <th v-if="props.column.field == 'name'"> {{ props.column.label | translate }}</th>
                                <th v-if="props.column.field == 'datetime'"> {{ props.column.label | translate }}</th>
                                <th v-if="props.column.field == 'duration'"> {{ props.column.label | translate }}</th>
                                <th v-if="props.column.field == 'reason'"> {{ props.column.label | translate }}</th>
                            </template>
                            <template slot="table-row" scope="props">
                                <td v-if="props.column.field == 'type'"><span style="border: 5px; border-radius:5px; padding:3px" v-bind:class="Typestyle(props.row.type)"> {{props.row.type | eventTypeFilter | translate}}</span></td>
                                <td v-if="props.column.field == 'name'"> {{ props.row.name }}</td>
                                <td v-if="props.column.field == 'datetime'"> {{ props.row.datetime | unixTime }}</td>
                                <td v-if="props.column.field == 'duration'"> {{ props.row.duration |milliseconds }}</td>
                                <td v-if="props.column.field == 'reason'"><span v-bind:class="reasonCode(props.row.reason.code)"> {{ props.row.reason.code }} {{ props.row.reason.detail }}</span></td>

                            </template>
                        </vue-good-table>
                    </div>
                </div>

            </div>
            <div class="col col-sm-6">
                <div class="box box-primary direct-chat direct-chat-primary">
                    <div class="box-header with-border">
                        <center>
                            <h3 class="box-title">Tickets</h3>
                        </center>
                        <div class="box-tools pull-right">
                            <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i>
                </button>

                            <button type="button" class="btn btn-box-tool" data-widget="remove"><i class="fa fa-times"></i></button>
                        </div>
                    </div>
                    <div class="box-body">

                        <div class="col col-lg-12 col-sm-12 col-xs-12">

                            <div class="col col-lg-6 col-sm-6 col-xs-6">
                                <div class="small-box bg-red">
                                    <div class="inner">
                                        <h2 class="text-center"><img class="img-thumbnail" src="../../assets/dist/img/UDR_LOGO.png" />{{ $t('UPTIMEROBOT.PENDING_TICKETS')}} </h2>
                                        <hr>
                                        <div class="text-center font-weight-bold" style="font-size: 100px; ">{{udrTickets}}</div>
                                    </div>
                                </div>

                            </div>

                            <div class="col col-lg-6 col-sm-6 col-xs-6">
                                <div class="small-box bg-blue">
                                    <div class="inner">
                                        <h2 class="text-center"><img class="img-thumbnail" src="../../assets/dist/img/utd_logo.jpg" />{{ $t('UPTIMEROBOT.PENDING_TICKETS')}} </h2>
                                        <hr>
                                        <div class="text-center font-weight-bold" style="font-size: 100px;">{{utdTickets}}</div>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </div>

        </div>

    </div>

</section>
</template>

<script>
import swal from 'sweetalert';
export default {
    name: "uptimerobot",
    created() {
        this.getMonits();
        this.getTickets();
        this.reloj(this.timeToReboot);
        //305550
    },
    data() {
        return {
            completedSteps: 5,
            grosor:15,
            size:150,
            speed:400,
            enventsColums: [{
                    label: "UPTIMEROBOT.EVENT",
                    field: "type",
                    html: true,
                    filterable: true
                },
                {
                    label: "UPTIMEROBOT.MONITOR",
                    field: "name",
                    filterable: true
                },
                {
                    label: "UPTIMEROBOT.DATE",
                    field: "datetime",
                    filterable: true
                },
                {
                    label: "UPTIMEROBOT.DURATION",
                    field: "duration",

                    filterable: true
                },
                {
                    label: "UPTIMEROBOT.RAZON",
                    field: "reason",
                    filterable: true
                }
            ],
            thisLink: `${window.location.origin}/monits`,
            hora: "00:00",
            eventsRows: [],
            title: "UPTIMEROBOT.MONITORS_SISTEM",
            QUICK_STATS: "UPTIMEROBOT.QUICK_STATS",
            DOWN_MONIT: "UPTIMEROBOT.DOWN_MONIT",
            PAUSED_MONIT: "UPTIMEROBOT.PAUSED_MONIT",
            UP_MONIT: "UPTIMEROBOT.UP_MONIT",
            up: 0,
            downs: 0,
            pauses: 0,
            maxZise: 0,
            timeToReboot: 60,
            udrTickets: 0,
            utdTickets: 0,
            Monitorslist: {
                paused: [],
                not_checked_yet: [],
                up: [],
                seems_down: [],
                down: []
            },
            status: {
                paused: 0,
                not_checked_yet: 1,
                up: 2,
                seems_down: 8,
                down: 9
            },
            logType: {
                down: 1,
                up: 2,
                paused: 99,
                started: 98
            },
            columns: [{
                    field: this.typeFn,
                    type: "string",
                    html: true,
                    filterable: true
                },
                {
                    field: "friendly_name",
                    type: "string",
                    filterable: true
                }
            ]
        };
    },
    methods: {
        reloj(tiempo) {
            let original = tiempo;
            tiempo = tiempo * 1000;
            tiempo = 1000 * Math.round(tiempo / 1000); // round to nearest second
            let d = new Date(tiempo);

            this.hora = d.getUTCMinutes() + ":" + d.getUTCSeconds();
            if (d.getUTCMinutes() + ":" + d.getUTCSeconds() > "0:0") {
                setTimeout(() => {
                    this.reloj(original - 1);
                }, 1000);
            } else {
                window.location.reload();
            }
        },
        reasonCode(code) {
            if (code == 200 || code == 2) {
                return "text-green";
            } else if (code == 98) {
                return "text-blue";
            } else if (
                code == 333333 ||
                code == 404 ||
                code == 500 ||
                code == 502 ||
                code == 503
            ) {
                return "text-red";
            } else {
                return "";
            }
        },
        Typestyle: function (type) {
            switch (type) {
                case this.logType.up:
                    return "bg-green fa fa-arrow-up text-white";
                    break;
                case this.logType.down:
                    return "bg-red fa fa-arrow-down text-white";
                    break;
                case this.logType.paused:
                    return "bg-black fa fa-pause text-white";
                    break;
                case this.logType.started:
                    return "bg-blue fa fa-play text-white";
                    break;
            }
        },
        typeFn(monitor) {
            let monitorsType = ["HTTP(s)", "Keyword", "Ping", "Port"];
            return `<b class="btn-xs" style="color:green">${
        monitorsType[monitor.type - 1]
      }</b>`;
        },
        separate(monits) {
            let self = this;
            let count = 0;
            let monitList = self.Monitorslist;

            let f = counter => {
                let monit = monits[counter];

                for (let event of monit.logs) {
                    event.name = monit.friendly_name;

                    self.eventsRows.push(event);
                }

                switch (monit.status) {
                    case self.status.up:
                        self.up++;
                        monitList.up.push(monit);
                        break;
                    case self.status.down:
                        self.down++;
                        monitList.down.push(monit);
                        break;
                    case self.status.paused:
                        self.paused++;
                        monitList.paused.push(monit);
                        break;
                }
                if (counter < self.maxZise - 1) {
                    setTimeout(() => {
                        f(counter + 1);
                    }, 100);
                }
            };

            f(count);
        },
        async getMonits() {
            let self = this;
            try {
                let response = await this.$store.state.services.UptimeService.getMonits();

                self.maxZise = response.data.pagination.total;

                this.separate(response.data.monitors);
            } catch (error) {
                console.log(JSON.stringify(error, null, 2));

                swal({
                    title: 'Problema con la carga de datos de UptimeRobot',
                    text: JSON.stringify(error, null, 2),
                    icon: "warning",
                    buttons: this.$t('REFRESH'),
                    dangerMode: true
                }).then(willRefresh => {
                    if (willRefresh) {
                        window.location.reload();
                    }
                })
            }
        },
        async getTickets() {
            let self = this;
            try {
                let response = await this.$store.state.services.FreshdeskService.getTickets();

                this.udrTickets = response.data.UDR;
                this.utdTickets = response.data.UTD;

            } catch (error) {
                swal({
                    title: 'Problema con la carga de tickets',
                    text: JSON.stringify(error, null, 2),
                    icon: "warning",
                    buttons: this.$t('REFRESH'),
                    dangerMode: true
                }).then(willRefresh => {
                    if (willRefresh) {
                        window.location.reload();
                    }
                })
                console.log(JSON.stringify(error, null, 2));
            }
        }
    },
    filters: {
        eventTypeFilter: type => {
            let logType = {
                down: 1,
                up: 2,
                paused: 99,
                started: 98
            };
            switch (type) {
                case logType.up:
                    return `Up`;
                    break;
                case logType.down:
                    return `Down`;
                    break;
                case logType.started:
                    return `Started`;
                    break;
                case logType.paused:
                    return `Paused`;
                    break;
            }
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/UptimeRobot/index.vue